// Geliştirici kısayolları (login ekranındaki "Hızlı Giriş" çipleri) yalnız yerel
// makinede gösterilir. Fail-closed: liste dışındaki tüm host'larda (app.zekabin.com,
// tapp.zekabin.com ve bilinmeyen host'lar dahil) çipler gizlenir.
const DEV_LOGIN_HOSTS = ["localhost", "127.0.0.1", "[::1]"];

export const isDevLoginEnabled = (): boolean =>
  DEV_LOGIN_HOSTS.includes(window.location.hostname);
